import axios from 'axios';
import { getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/users';

const getLogin = async ({ username, password }) => {
  return axios
    .post(endPoint.concat('/login'), { username, password })
    .then((res) => res)
    .catch((error) => error.response);
};

const updateIsActiveUser = async (id) => {
  const token = localStorage.getItem('token');
  return axios
    .patch(
      endPoint.concat(`/${id}`),
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res)
    .catch((error) => error.response);
};

export { updateIsActiveUser };
export default getLogin;
